import ConditionalRouteView from "./ConditionalRoute.view";
import { IConditionalRouteProps } from "./ConditionalRoute.types";
import React from "react";

const ConditionalRoute: React.FC<IConditionalRouteProps> = props => (
  <ConditionalRouteView {...props} />
);

export default ConditionalRoute;
